import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ModelToken } from '@sleed/bizcommerce-api';
import { modelsApi } from '~/lib/api/client';
import { formToToken, type ModelFormValues } from '~/lib/schemas/model';

export const modelKeys = {
	all: ['models'] as const,
	list: () => [...modelKeys.all, 'list'] as const
};

export function useModelsList() {
	return useQuery<ModelToken[]>({
		queryKey: modelKeys.list(),
		queryFn: async () => (await modelsApi.getAll()).data.items ?? []
	});
}

export function useModelMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: modelKeys.list() });
	const create = useMutation({
		mutationFn: async (form: ModelFormValues) => (await modelsApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: ModelFormValues) => (await modelsApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await modelsApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
